export enum Path {
  MAIN = '/',
  INDEX = `/index`,
  PRODUCTS = `/products`,
  PRODUCT_DETAILS = `/products/:symbol`,
  PORTFOLIO = '/portfolio',
  STAKING = '/staking',
  ABOUT = '/about',
  TERMS = '/terms-and-conditions',
  PRIVACY = '/privacy-policy',
}

interface RedirectObject {
  from: string
  to: string
}

/**
 * Add redirect routes here
 */
export const redirectPaths: RedirectObject[] = [
  {
    from: `/index/:symbol`,
    to: Path.PRODUCT_DETAILS,
  },
]

export default Path
